import API, { config } from './_main';
import * as AOIModule from './../Modules/AOIModule';

export function getAOIList(userId: number) {
    return API.get(`domain-of-interest/area`, config());
}

export function addAOI(aoiData: AOIModule.Types.AddAreaOfInterestRequest) {
    return API.post('domain-of-interest/area', aoiData, config());
}

export function deleteAOI(aoiID: number) {
    return API.delete(`domain-of-interest/area/${aoiID}`, config());
}

export function updateAoi(aoiData: AOIModule.Types.AddAreaOfInterestRequest, aoiId: number) {
    return API.put(`domain-of-interest/area/${aoiId}`, aoiData, config());
}



// WEBPACK FOOTER //
// ./src/Connectors/AOIConnector.ts